import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import {
  compose,
  formatNumbers,
  newFormatPrice,
  RewardTypes,
} from '../../services/utilityFunctions';
import translate from '../translate';
import CurrencyProp from '../../sections/profile/propTypes/currencyProp';
import ConfigsContext from '../../contextProviders/ConfigsContext';

const getCardInfo = (t, item, recurrence) => {
  const { _id, value: valueItem, currency } = item;
  let image = '';
  let label = '';
  let value = valueItem;
  switch (_id) {
    case RewardTypes.COMMISSION:
      image = '/images/rewards/totalCommissions.svg';
      value = newFormatPrice(valueItem, true, currency.code);
      switch (recurrence) {
        case 'weekly':
          label = t('dashboard.rewards.commissions_this_week');
          break;
        case 'monthly':
          label = t('dashboard.rewards.commissions_this_month');
          break;
        case 'quarterly':
          label = t('dashboard.rewards.commissions_this_quarter');
          break;
        default:
          label = t('rewards_totalOfCommissions');
          break;
      }
      break;
    case RewardTypes.COINS:
      image = '/images/rewards/coins.svg';
      label = t('rewards_coins');
      value = formatNumbers(valueItem, false, false);
      break;
    case RewardTypes.CHARITY_COINS:
      image = '/images/rewards/charityCoins.svg';
      label = t('rewards_charityCoins');
      value = formatNumbers(valueItem, false, false);
      break;
    case RewardTypes.COUPONS:
      image = '/images/rewards/coupon.svg';
      label = t('rewards_coupon');
      value = formatNumbers(valueItem, false, false);
      break;
    case RewardTypes.VOUCHERS:
      image = '/images/rewards/voucher.svg';
      label = t('rewards_voucher');
      value = formatNumbers(valueItem, false, false);
      break;
    case RewardTypes.WALLET_BALANCE:
      image = '/images/rewards/voucher.svg';
      label = t('dashboard.rewards.wallet_balance');
      value = newFormatPrice(valueItem, true, currency.code);
      break;
    default:
      break;
  }
  return { image, label, value };
};

const RewardCardItem = ({ t, item }) => {
  const { organization } = useContext(ConfigsContext);
  const { recurrence } = organization.directSelling || {};

  const { image, label, value } = getCardInfo(t, item, recurrence);
  return (
    <div className="rewards-dashboard-container">
      <div className="reward-item">
        <div className="image-container">
          <img src={image} alt="reward" />
        </div>
        <div className="content-container">
          <div className="label">{label}</div>
          <div className="value no-wrap-value">{value}</div>
        </div>
      </div>
    </div>
  );
};

RewardCardItem.propTypes = {
  t: PropTypes.func.isRequired,
  item: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.shape(CurrencyProp.propType),
    ]).isRequired,
  }).isRequired,
};

export default compose(translate)(RewardCardItem);
